



import React, { useEffect, useLayoutEffect, useState, Fragment } from 'react';
import { IonContent, IonLabel, IonTextarea,  IonButton, IonGrid, IonRow, IonCol, IonInput, IonIcon, IonDatetime } from '@ionic/react';
import './../../Tab3.css';
import { useUser } from '../../../context/UserContext';
import { print, refreshCircleOutline, save, documentText, refreshSharp, arrowDownSharp, printSharp } from 'ionicons/icons';

import { useTest } from '../../../context/TestContext';
import { toasterMsg } from '../toast/toasterMsg';
import { mbFireSablonVaadSet, isNullMb } from '../../../utils';
import jsPDF from 'jspdf';

import domtoimage from 'dom-to-image';

const Sayfa4Yetki: React.FC = () => {
        
  const {pathUser} = useUser();
  const {parDict, sablon, siraNo, inputChanged, propDetay} = useTest();
  const [refresh, setRefresh] = useState(false);
  const [yetkiText, setYetkiText] = useState('');


    
function  createPDF(val: any){

  let node:any = document.getElementById('my-nodeyetki');
  // console.log(' node '+node);
  const options = { background: 'white', height: 1245, width: 795 };

  domtoimage.toPng(node,options)
      .then(function (dataUrl:any) {
          var img = new Image();
          img.src = dataUrl;
          // // console.log(' dataUrl '+dataUrl);
          document.body.appendChild(img);
          const doc = new jsPDF();   //Add image Url to PDF
          doc.addImage(dataUrl, 'png', 20,10, 172, 310);              
          doc.save('pdfYetkiDocument.pdf');
      })
      .catch(function (error: any) {
          console.error('oops, something went wrong!', error);
      });
  };

    function  handleKaydet(val: any){  
      let mysirano = isNullMb(localStorage.getItem('vsirano'),'0');
      if (siraNo===0 || mysirano==='0') {
        toasterMsg('SıraNo=0 olamaz. Güncellemek için önce bir emlak seçmeniz lazım.','danger',10); 
        return false;
      }
      let estateObj = {
        ysirano: localStorage.getItem('ysirano'),
        ytapubilgi: isNullMb(localStorage.getItem('ytapubilgi'),''),
        ymulkadres: isNullMb(localStorage.getItem('ymulkadres'),''),
        ytelefonu: isNullMb(localStorage.getItem('ytelefonu'),''),
        yadresi: isNullMb(localStorage.getItem('yadresi'),''),
        yadisoyadi: isNullMb(localStorage.getItem('yadisoyadi'),''),
        ymulkunvan: isNullMb(localStorage.getItem('ymulkunvan'),''),
        ytelnomuz: isNullMb(localStorage.getItem('ytelnomuz'),''),
        yadresimiz: isNullMb(localStorage.getItem('yadresimiz'),''),
        yadimiz: isNullMb(localStorage.getItem('yadimiz'),''),
        yunvanimiz: isNullMb(localStorage.getItem('yunvanimiz'),''),
        ysatisfiyat: isNullMb(localStorage.getItem('ysatisfiyat'),''),
        ycezafaizoran: isNullMb(localStorage.getItem('ycezafaizoran'),''),
        ymahksehir: isNullMb(localStorage.getItem('ymahksehir'),''),
        ykomoran: isNullMb(localStorage.getItem('ykomoran'),''),
        ytarihi: isNullMb(localStorage.getItem('ytarihi'),''),
        yvazgecoran: isNullMb(localStorage.getItem('yvazgecoran'),''),
        yfesihoran: isNullMb(localStorage.getItem('yfesihoran'),''),
        ysatisvazgecoran: isNullMb(localStorage.getItem('ysatisvazgecoran'),''),
        ysozsure: isNullMb(localStorage.getItem('ysozsure'),''),
      };
      const result = mbFireSablonVaadSet(pathUser,'doc/',mysirano+'/'+mysirano+'/','yetki',estateObj);
      toasterMsg('Satış Yetkisi Kaydedildi.'+result,'primary',10); 
    }

    function  handleYenile(val: any){  
        sablonYetkiSablonGetir();  
        setRefresh(true);
    }

    const sablonYetkiSablonGetir = () => {
      if (sablon !== undefined && sablon !== null) {
        let item = Object.keys(sablon).map((item:any) =>  parDict[sablon[item]]['Text']);
        if (item !== undefined && item !== null && item[0] !== undefined && item[0] !== null) {
          Object.keys(item[0]).map((field) =>  {
            // console.log(' element '+JSON.stringify(field)+ ' : '+item[0][field]);
            localStorage.setItem(field, item[0][field]);
          } );    
        }
      }    // 
      yetkiGetir();    
    };

    const parYetkiGetir = () => {
      if (sablon !== undefined && sablon !== null) {        
         Object.keys(sablon).map((item:any) =>   {
          // console.log(JSON.stringify( ' yetki yetki  ************ '+parDict[sablon[item]]));
           setYetkiText(parDict[sablon[item]]['Value']) ;
          });
      }     
    };
    // emlak üzerinde kaydedilen form
    const yetkiGetir = () => {
      let item: any;
      if (propDetay !== undefined && propDetay !== null && siraNo! > 0) {
        // console.log(' propDetay ******** : '+JSON.stringify(propDetay))
        propDetay.map((profile: any) => (
          Object.keys(profile['detail'][siraNo!][siraNo!]).map((data, index) => {
            if (data==='yetki') item = profile['detail'][siraNo!][siraNo!]['yetki']    
          })));
          if (item!==undefined && item!==null) {
            Object.keys(item).map((field:any)=>  localStorage.setItem(field, item[field]) )
          }
      }      
    };

    function  handleKaydetSablon(val: any){
      let estateObj = {
        ysirano: localStorage.getItem('ysirano'),
        ytapubilgi: isNullMb(localStorage.getItem('ytapubilgi'),''),
        ymulkadres: isNullMb(localStorage.getItem('ymulkadres'),''),
        ytelefonu: isNullMb(localStorage.getItem('ytelefonu'),''),
        yadresi: isNullMb(localStorage.getItem('yadresi'),''),
        yadisoyadi: isNullMb(localStorage.getItem('yadisoyadi'),''),
        ymulkunvan: isNullMb(localStorage.getItem('ymulkunvan'),''),
        ytelnomuz: isNullMb(localStorage.getItem('ytelnomuz'),''),
        yadresimiz: isNullMb(localStorage.getItem('yadresimiz'),''),
        yadimiz: isNullMb(localStorage.getItem('yadimiz'),''),
        yunvanimiz: isNullMb(localStorage.getItem('yunvanimiz'),''),
        ysatisfiyat: isNullMb(localStorage.getItem('ysatisfiyat'),''),
        ycezafaizoran: isNullMb(localStorage.getItem('ycezafaizoran'),''),
        ymahksehir: isNullMb(localStorage.getItem('ymahksehir'),''),
        ykomoran: isNullMb(localStorage.getItem('ykomoran'),''),
        ytarihi: isNullMb(localStorage.getItem('ytarihi'),''),
        yvazgecoran: isNullMb(localStorage.getItem('yvazgecoran'),''),
        yfesihoran: isNullMb(localStorage.getItem('yfesihoran'),''),
        ysatisvazgecoran: isNullMb(localStorage.getItem('ysatisvazgecoran'),''),
        ysozsure: isNullMb(localStorage.getItem('ysozsure'),''),

      };
      const result = mbFireSablonVaadSet(pathUser,'json/','23/','Text',estateObj);
      toasterMsg('Şablon kaydetme sonucu ..','primary',10);   
    };

    const sablonYetki = () => {
      if (sablon !== undefined && sablon !== null)
      Object.keys(sablon).map((item:any) =>   setYetkiText(parDict[sablon[item]]['Value']) );
    };

    function  handleYenileYazi(val: any){
      sablonYetki();  
      setRefresh(true);
    }

    function  handleSablonUygula(){
      let metin = yetkiText;
      let pre = "y";
      const regexp: any = /\[[a-z]*]/g;
      let indexes1 = [...metin.matchAll(regexp)];
      let words = new Array([]);
      let wordsPure = new Array([]);
      indexes1.map((element) => {
        let wrd: any = element.toString().trim();
        let wrdPure = wrd.replace('[','').replace(']','').trim();
        if (wrdPure.length) {
          words.push(wrd);
          wordsPure.push(wrdPure);   
          return null;         
        }        
      });    
      wordsPure.map((element, index) => {    // alan isimler şablandaki gibi ama parantezsiz geldi.
        if (element.length) {
          let localVal = isNullMb(localStorage.getItem(pre+element+''),'');
          if (localVal.length) {        // local storage değer var ise.
            metin = metin.replace('['+element+']',localVal);
            console.log(' found '+index+' '+localVal+' element : '+element);
          }
          setYetkiText(metin);
        } 
        return null;     
      });
     // toasterMsg('Şablon kaydetme sonucu ..'+JSON.stringify(wordsPure),40);   
      // find all values from localstorage  
    };
    
    useEffect(() => {
      // console.log(' page 4 use effect ');
      parYetkiGetir();
      sablonYetkiSablonGetir();
  },[])
  
  useLayoutEffect(()=>{
    if (refresh) {
      // console.log(' page 4 use useLayoutEffect ');
      setRefresh(false);    
       } 
  },[refresh])


  return (
    <Fragment>
         <IonContent>    
  
         <IonButton onClick={handleKaydet} color="danger">Kaydet
              <IonIcon slot="start" icon={save} /></IonButton>            
              <IonButton onClick={handleYenile} color="danger"><IonIcon icon={refreshSharp} slot="start" /></IonButton>
              <IonButton onClick={handleKaydetSablon} color="danger">Şablon Kaydet 
              <IonIcon slot="start" icon={documentText} /></IonButton>               
          
        <IonGrid>
              <IonRow>
                <IonCol size="3" size-sm>  <IonLabel>SıraNo</IonLabel>  </IonCol>
                <IonCol size="3" size-sm> <IonInput id="ysirano" readonly  value={siraNo}  ></IonInput>  </IonCol>
                <IonCol size="3" size-sm>  <IonLabel>SatışFiyat</IonLabel>   </IonCol>
                <IonCol size="3" size-sm>  <IonInput id="ysatisfiyat" onIonChange={inputChanged} value={localStorage.getItem('ysatisfiyat')} ></IonInput>   </IonCol>
              </IonRow>
  
              <IonRow>
                <IonCol size="3" size-sm>  <IonLabel>Ünvanımız</IonLabel>   </IonCol>
                <IonCol size="4" size-sm>  <IonInput id="yunvanimiz"   onIonChange={inputChanged}  value={localStorage.getItem('yunvanimiz')}  ></IonInput>   </IonCol>
                 <IonCol size="2" size-sm>  <IonLabel>Adımız</IonLabel>   </IonCol>
                 <IonCol size="3" size-sm>  <IonInput id="yadimiz"   onIonChange={inputChanged}  value={localStorage.getItem('yadimiz')}  ></IonInput>   </IonCol>         
              </IonRow> 
  
                <IonRow>
                <IonCol size="3" size-sm>  <IonLabel>Adresimiz</IonLabel>   </IonCol>
                <IonCol size="9" size-sm>  <IonInput id="yadresimiz"   onIonChange={inputChanged}  value={localStorage.getItem('yadresimiz')}  ></IonInput>   </IonCol>
              </IonRow>         
              <IonRow>
                <IonCol size="3" size-sm>  <IonLabel>Tel.No.muz</IonLabel>   </IonCol>
                <IonCol size="9" size-sm>  <IonInput id="ytelnomuz"   onIonChange={inputChanged}  value={localStorage.getItem('ytelnomuz')}  ></IonInput>   </IonCol>
              </IonRow>
  
              <IonRow>
                <IonCol size="3" size-sm>  <IonLabel>MülkÜnvan</IonLabel>   </IonCol>
                <IonCol size="3" size-sm>  <IonInput id="ymulkunvan"   onIonChange={inputChanged}  value={localStorage.getItem('ymulkunvan')}  ></IonInput>   </IonCol>
                 <IonCol size="3" size-sm>  <IonLabel>Adı Soyadı</IonLabel>   </IonCol>
                <IonCol size="3" size-sm><IonInput id="yadisoyadi"   onIonChange={inputChanged}   value={localStorage.getItem('yadisoyadi')} ></IonInput>  </IonCol>             
              </IonRow> 
              <IonRow>
                <IonCol size="3" size-sm>  <IonLabel>Adresi</IonLabel>   </IonCol>
                <IonCol size="9" size-sm>  <IonInput id="yadresi"   onIonChange={inputChanged}  value={localStorage.getItem('yadresi')}  ></IonInput>   </IonCol>
              </IonRow>         
              <IonRow>
                <IonCol size="3" size-sm>  <IonLabel>Telefonu</IonLabel>   </IonCol>
                <IonCol size="9" size-sm>  <IonInput id="ytelefonu"   onIonChange={inputChanged}   value={localStorage.getItem('ytelefonu')} ></IonInput>   </IonCol>
              </IonRow>
  
              <IonRow>
                <IonCol size="3" size-sm>  <IonLabel>MülkAdres</IonLabel>   </IonCol>
                <IonCol size="9" size-sm> <IonInput id="ymulkadres"   onIonChange={inputChanged}  value={localStorage.getItem('ymulkadres')}  ></IonInput>   </IonCol>
              </IonRow>
  
              <IonRow>         
                <IonCol size="3" size-sm>  <IonLabel>TapuBilgi</IonLabel>   </IonCol>
                <IonCol size="3" size-sm> <IonInput id="ytapubilgi"   onIonChange={inputChanged}  value={localStorage.getItem('ytapubilgi')}  ></IonInput>   </IonCol>
                 <IonCol size="3" size-sm>  <IonLabel>Kom.Oran</IonLabel>   </IonCol>
                <IonCol size="3" size-sm>  <IonInput id="ykomoran"   onIonChange={inputChanged}   value={localStorage.getItem('ykomoran')} ></IonInput>   </IonCol>               
              </IonRow> 
        
  
              <IonRow>  
                <IonCol size="3" size-sm>  <IonLabel>Vazgeç.Oran</IonLabel>   </IonCol>
                <IonCol size="3" size-sm>  <IonInput id="yvazgecoran"   onIonChange={inputChanged}  value={localStorage.getItem('yvazgecoran')}  ></IonInput>   </IonCol>
                <IonCol size="3" size-sm>  <IonLabel>Fesih.Oran</IonLabel>   </IonCol>
                <IonCol size="3" size-sm>  <IonInput id="yfesihoran"   onIonChange={inputChanged}  value={localStorage.getItem('yfesihoran')}  ></IonInput>   </IonCol>  

              </IonRow>
              <IonRow>
    
                <IonCol size="4" size-sm>  <IonLabel>Satış.Vazgeç.Oran</IonLabel>   </IonCol>
                <IonCol size="2" size-sm>  <IonInput id="ysatisvazgecoran"   onIonChange={inputChanged}  value={localStorage.getItem('ysatisvazgecoran')}  ></IonInput>   </IonCol>
                <IonCol size="4" size-sm>  <IonLabel>Ceza.Faiz.Oran</IonLabel>   </IonCol>
                <IonCol size="2" size-sm>  <IonInput id="ycezafaizoran"   onIonChange={inputChanged}  value={localStorage.getItem('ycezafaizoran')}  ></IonInput>   </IonCol>
  
              </IonRow>

              <IonRow>
              <IonCol size="3" size-sm>  <IonLabel>Mahk.Şehir</IonLabel>   </IonCol>
                <IonCol size="3" size-sm>  <IonInput id="ymahksehir"   onIonChange={inputChanged}   value={localStorage.getItem('ymahksehir')} ></IonInput>   </IonCol>
                <IonCol size="3" size-sm>  <IonLabel>Sözl.Süre</IonLabel>   </IonCol>
                <IonCol size="3" size-sm>  <IonInput id="ysozsure"   onIonChange={inputChanged}   value={localStorage.getItem('ysozsure')} ></IonInput>   </IonCol>
                </IonRow>

                <IonRow>
              <IonCol size="3" size-sm>  <IonLabel>AylıkCeza%</IonLabel>   </IonCol>
                <IonCol size="3" size-sm>  <IonInput id="yaylikcezaoran"   onIonChange={inputChanged}   value={localStorage.getItem('yaylikcezaoran')} ></IonInput>   </IonCol>

                </IonRow>

              <IonRow>
                <IonCol size="3" size-sm>  <IonLabel>Tarihi</IonLabel>  </IonCol>
                <IonCol size="9" size-sm> <IonDatetime id="ytarihi"   
                   onIonChange={inputChanged}  displayFormat="DD.MM.YYYY"  
                   value={localStorage.getItem('ytarihi')} 
                    monthNames={'Ocak, Şubat, Mart, Nisan, Mayıs, Haziran, Temmuz, Ağustos, Eylül, Ekim, Kasım, Aralık'}                      
                    pickerFormat="DD.MMMM.YYYY"   
                ></IonDatetime>  </IonCol>
              </IonRow>
  
              <IonRow>
                    <IonButton onClick={handleSablonUygula} color="danger"><IonIcon icon={arrowDownSharp} slot="start" /> </IonButton>              
                    <IonButton onClick={handleYenileYazi} color="danger"><IonIcon icon={refreshSharp} slot="start" /></IonButton>                    
                    <IonButton onClick={createPDF} color="danger"><IonIcon icon={printSharp} slot="start" /> </IonButton>
                </IonRow>  

            </IonGrid>   
  
          <IonTextarea id="yyetkitext" rows={20} value={yetkiText}    onIonChange={inputChanged}  ></IonTextarea>
  
        </IonContent>
        <div id="my-nodeyetki">
          {(yetkiText) ? 
          (yetkiText.split('*').map((item, index)=><div key={"p"+index}>{(item.length<2) ? <hr/> : item}</div>) ) : 
          null }  
     </div>   
     </Fragment>
    );

// const met = {met: "SATILIKLARDA YETKİ BELGESİ SCÖZLEŞMESİ.**\nSözleşme No: [sirano] / Tarihi:[tarihi].**\n1-TARAFLAR.*\nEmlak Komisyoncusu. \nÜnvanı: [unvanimiz].*\nAdı Soyadı:[yadimiz].*\nAdresi:[adresimiz].*\nTelefon: [telnomuz].*\nTaşınmaz Sahibi / Yetkilisi. \nÜnvanı:[mulkunvan].*\nAdı Soyadı:[adisoyadi].*\nAdresi:[adresi].*\nTelefon: [telefonu].**\n2-SÖZLEŞMENİN KONUSU.*\nAşağıda bilgileri bulunan taşınmazın üçüncü kişilere satışı konusunda vereceği aracılık hizmetine ilişkin olarak emlak komisyoncusuna yetki verilmesi ve bu konuda tarafların hak ve yükümlülüklerini kapsar.*\nTaşınmazın Adresi:[mulkadres].*\nTapu Bilgileri:[tapubilgi].**\n3-SÖZLEŞMENİN KONUSU.\n A- Emlak komisyoncusu, yukarıda bilgileri verilen taşınmazın; [satisfiyat] bedelle satışı konusunda müşteri bulmayı yükümlenir. Emlak komisyoncusu bu hizmeti bizzat yürüteceği gibi bu konuda bir başka emlak komisyoncusu ile de ortak hareket edebilir.* \nB- Satıcı, Emlak komisyoncusuna (A fıkrasında ) gösterilen satış bedelinin [komoran] oranında komisyon ücreti ödemeyi kabul ve taahhüt eder.*\nC- Sözleşmenin süresi [sozsure] aydır. Sözleşme süresi içinde taraflar sözleşmeyi mücbir sebepler dışında tek taraflı olarak fesh edemez. Satıcı sözleşmeyi süre dolmadan tek yanlı olarak fesh ederse, emlak komisyoncusuna sözleşmede yazılı satış bedeli üzerinden [cezafaizoran] oranında bir meblağ ödemeyi kabul ve taahhüt eder.*\nD- Taraflar sözleşme bitiminden 15 gün öncesine kadar, sözleşmenin yenilenmeyeceğini yazılı olarak karşı tarafa ihbar etmedikleri takdirde, sözleşme ayni koşullarda ve C fıkrasındaki süre kadar yenilenmiş sayılır.*\nE- Satıcı işbu sözleşme süresince taşınmazın satışı amacıyla pazarlanması konusunda hiçbir kişi ve kuruluşa ayrıca pazarlama yetkisi veremeyeceği gibi, bizzat kendisi de satamaz. Aksi takdirde satıcı sözleşmede belirtilen satış bedeli üzerinden [fesihoran] oranındaki meblağı emlak komisyoncusuna ödemeyi kabul ve taahhüt eder.*\nF- Satıcı, Emlak komisyoncusunun sözleşmedeki özel ve genel şartlar çerçevesinde bulup önerdiği alıcı adayına satış yapmaktan imtina ederse, satış sözleşmesinin yapılması imkanı hazırlamakla görevini tamamlamış bulunan emlak komisyoncusuna yukarıda belirtilen satış bedelinin [vazgecoran] oranında bir meblağı komisyon ücreti olarak ödemeyi kabul ve taahhüt eder.*\nG- Sözleşme süresi içersinde, Emlak komisyoncusunun bulduğu adaylara ilişkin olarak satıcıya yaptıkları tekliflerin değerlendirilmesinin, sözleşme tarihi bitim tarihini aşması halinde, satıcının bu konuya ilişkin cevabını bildirinceye kadar geçecek süre sözleşme içersinde sayılır. Bu halde de sözleşme koşulları aynen uygulanır.*\nH- Hisseli taşınmazlarda aşağıdaki imzası bulunan paydaş veya diğer paydaşların muvakatini aldıklarını en başta beyan etmiş olmakla, paydaşların herhangi birinin sözleşmenin icrasına engel çıkarması halinde sözleşmeden doğan komisyon ücreti dahil tüm sorumlulukları yerine getirmeyi kabul ve taahhüt eder.*\nI- Emlak komisyoncusunun iş bu sözleşmeden doğacak alacaklarının zamanında ödenmemesi halinde aylık [aylikcezaoran] temerrüt faizi uygulanır.*\nJ- İşbu sözleşmede şayet mal sahibi bir vekille temsil edilmişse, vekalete dayalı yetkinin varlığı ve geçerliliği vekili olduğunu beyan eden kişi ispat etmek zorundadır. Yetkisiz temsil veya vekaletin hükümsüğü gibi hallerde işbu sözleşme ile mal sahibine yüklenen bütün borçlar ve sorumluluklar velaten imza koyan kişiye aittir.* \nK- İşbu sözleşmeden doğacak uyuşmazlıkların çözümünde [mahksehir] Mahkemeleri ve İcra Daireleri yetkilidir.*\nL- İşbu sözleşme iki nüsha düzenlenmiş olup taraflar birer nüsha tevliğ edilmiştir.***\nTaşınmaz sahibi / Yetkilisi _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ Emlak Komisyoncusu "}

  };
  

export default Sayfa4Yetki;

 //    ysirano  ysatisfiyat  yunvanimiz yadimiz   yadresimiz  ytelnomuz  ymulkunvan  yadisoyadi  
 // yadresi  ytelefonu  ymulkadres  ytapubilgi ykomoran yvazgecoran  yfesihoran  ysatisvazgecoran 
 // ycezafaizoran ymahksehir  vtarihi

//  const met = {met: "SATILIKLARDA YETKİ BELGESİ SÖZLEŞMESİ.**\nSözleşme No: [sirano] / Tarihi:[tarihi].**\n1-TARAFLAR.*\nEmlak Komisyoncusu. \nÜnvanı: [unvanimiz].*\nAdı Soyadı:[yadimiz].*\nAdresi:[adresimiz].
// *\nTelefon: [telnomuz].*\nTaşınmaz Sahibi / Yetkilisi. \nÜnvanı: 
// [mulkunvan].*\nAdı Soyadı:
// [adisoyadi].*\nAdresi:
// [adresi].*\nTelefon: 
// [telefonu].**\n2-SÖZLEŞMENİN KONUSU.*\nAşağıda bilgileri bulunan taşınmazın üçüncü kişilere satışı konusunda vereceği aracılık hizmetine ilişkin olarak emlak komisyoncusuna yetki verilmesi ve bu konuda tarafların hak ve yükümlülüklerini kapsar.*\nTaşınmazın Adresi:
// [mulkadres].*\nTapu Bilgileri:
// [tapubilgileri].**\n3-SÖZLEŞMENİN KONUSU.\n A- Emlak komisyoncusu, yukarıda bilgileri verilen taşınmazın; 
// [satisfiyat] bedelle satışı konusunda müşteri bulmayı yükümlenir. Emlak komisyoncusu bu hizmeti bizzat yürüteceği gibi bu konuda bir başka emlak komisyoncusu ile de ortak hareket edebilir.* \nB- Satıcı, Emlak komisyoncusuna (A fıkrasında ) gösterilen satış bedelinin 
// [komoran] oranında komisyon ücreti ödemeyi kabul ve taahhüt eder.*\nC- Sözleşmenin süresi 
// [sozsure] aydır. Sözleşme süresi içinde taraflar sözleşmeyi mücbir sebepler dışında tek taraflı olarak fesh edemez. Satıcı sözleşmeyi süre dolmadan tek yanlı olarak fesh ederse, emlak komisyoncusuna sözleşmede yazılı satış bedeli üzerinden 
// [cezafaizoran] oranında bir meblağ ödemeyi kabul ve taahhüt eder.*\nD- Taraflar sözleşme bitiminden 15 gün öncesine kadar, sözleşmenin yenilenmeyeceğini yazılı olarak karşı tarafa ihbar etmedikleri takdirde, sözleşme ayni koşullarda ve C fıkrasındaki süre kadar yenilenmiş sayılır.*\nE- Satıcı işbu sözleşme süresince taşınmazın satışı amacıyla pazarlanması konusunda hiçbir kişi ve kuruluşa ayrıca pazarlama yetkisi veremeyeceği gibi, bizzat kendisi de satamaz. Aksi takdirde satıcı sözleşmede belirtilen satış bedeli üzerinden 
// [fesihoran] oranındaki meblağı emlak komisyoncusuna ödemeyi kabul ve taahhüt eder.*\nF- Satıcı, Emlak komisyoncusunun sözleşmedeki özel ve genel şartlar çerçevesinde bulup önerdiği alıcı adayına satış yapmaktan imtina ederse, satış sözleşmesinin yapılması imkanı hazırlamakla görevini tamamlamış bulunan emlak komisyoncusuna yukarıda belirtilen satış bedelinin 
// [vazgecoran] oranında bir meblağı komisyon ücreti olarak ödemeyi kabul ve taahhüt eder.*\nG- Sözleşme süresi içersinde, Emlak komisyoncusunun bulduğu adaylara ilişkin olarak satıcıya yaptıkları tekliflerin değerlendirilmesinin, sözleşme tarihi bitim tarihini aşması halinde, satıcının bu konuya ilişkin cevabını bildirinceye kadar geçecek süre sözleşme içersinde sayılır. Bu halde de sözleşme koşulları aynen uygulanır.*\nH- Hisseli taşınmazlarda aşağıdaki imzası bulunan paydaş veya diğer paydaşların muvakatini aldıklarını en başta beyan etmiş olmakla, paydaşların herhangi birinin sözleşmenin icrasına engel çıkarması halinde sözleşmeden doğan komisyon ücreti dahil tüm sorumlulukları yerine getirmeyi kabul ve taahhüt eder.*\n
// I- Emlak komisyoncusunun iş bu sözleşmeden doğacak alacaklarının zamanında ödenmemesi halinde aylık 
// [aylikcezaoran] temerrüt faizi uygulanır.*\nJ- İşbu sözleşmede şayet mal sahibi bir vekille temsil edilmişse, vekalete dayalı yetkinin varlığı ve geçerliliği vekili olduğunu beyan eden kişi ispat etmek zorundadır. Yetkisiz temsil veya vekaletin hükümsüğü gibi hallerde işbu sözleşme ile mal sahibine yüklenen bütün borçlar ve sorumluluklar velaten imza koyan kişiye aittir.* \nK- İşbu sözleşmeden doğacak uyuşmazlıkların çözümünde 
// [mahkemesehir] Mahkemeleri ve İcra Daireleri yetkilidir.*\nL- İşbu sözleşme iki nüsha düzenlenmiş olup taraflar birer nüsha tevliğ edilmiştir.***\nTaşınmaz sahibi / Yetkilisi _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ Emlak Komisyoncusu "}
